import React, { useState, useEffect } from 'react';
import './SchoolCourses.css';
import { apiPath, apiKey } from '../../constants'

function CourseCourses() {

    var userdata = JSON.parse(localStorage.getItem('kokos_userdata'))
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchSchoolCourses() {
            const response = await fetch(apiPath+'courses/schools/' + userdata.school_code, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const result = await response.json();
            setLoading(false);
            moidfyCourse(result);
        }
        fetchSchoolCourses();
    }, [])


    const moidfyCourse = (courseDetails) => {
        var modCourseArray = []
        for (var i = 0; i < courseDetails.length; i++) {
           var orgStr = courseDetails[i].course_code;
           var strArray = orgStr.split('+');
           var reCharacter = strArray[1].replace('-',' ')
           modCourseArray.push(reCharacter)
        }
        setCourses(modCourseArray);
        console.log(modCourseArray)
    }


    return (
        <div className="CourseCoursemain">
            {
                loading ?
                    <img className="loadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <table id="CourseCourse_table">
                        <tbody>
                            <tr>
                                <th>No.</th>
                                <th>Course</th>
                            </tr>
                        </tbody>
                        {
                            courses && courses.map((course_details, index) => {
                                return (
                                    <tbody key={index}>
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{course_details}</td>
                                        </tr>
                                    </tbody>
                                );
                            })
                        }
                    </table>
            }
        </div>
    );

}

export default CourseCourses;